
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import useAuthIsAccountActivated from '../../common/client/hooks/mysliveckyportal/useAuthIsAccountActivated';
import useAuthToken from '../../common/client/hooks/mysliveckyportal/useAuthToken';
import IfComp from '../../common/client/components/IfComp';
import AppPageStyle from '../../common/client/components/mysliveckyportal/AppPageStyle';

import useAdminPermission from '../../hooks/useAdminPermission';
import useNavigationItems  from '../../hooks/useNavigationItems';
import CheckUserAccountActivation from '../../components/auth/CheckUserAccountActivation';
import LoginInfo from '../../components/auth/LoginInfo';
import TileContent from '../../components/tiles/TileContent';

const classNames = mergeStyleSets({
    HomePage: {
        padding: 16
    },
    AppLink: {
        paddingTop: 8,
        paddingBottom: 8,
        fontSize: '18px',
        fontWeight: 'bold'
    },
});

const AppLink = ({link, target, title}) => {
    return (
        <Stack className={classNames.AppLink}>
            <a href={link} target={target}>{title}</a>
        </Stack>
    );
}

const AppsPage = (props) => {

    const token = useAuthToken();
    const activated = useAuthIsAccountActivated();
    const isAdmin = useAdminPermission();
    const navigationItems = useNavigationItems();

    return (
        <AppPageStyle
            appHeaderContent={<LoginInfo />}
            navigationItems={navigationItems}
            page="apps"
        >
            <CheckUserAccountActivation />
            <Stack className={classNames.HomePage}>
                <TileContent title="Seznam dostupných aplikací">
                    <IfComp cond={token && activated}>
                        <AppLink title="webHONITBA" link={`/client/webhonitba/honitba.php?sid=${token}`} />
                        <IfComp cond={isAdmin}>
                            <AppLink title="Administrace" link={`/client/webhonitba/admin.php?sid=${token}`} />
                            <AppLink title="Administrace - nová verze" link={`/admin`} />
                            <AppLink title="Monitoring" link={`/admin/dashboard`} />
                            <AppLink title="Parcely-online" link={`https://parcel-online.hfbiz.cz`} target="parcel_online" />
                            <AppLink title="Analýza historických dat ISKN" link={`https://parcel-history.hfbiz.cz`} target="parcel_history" />
                        </IfComp>
                    </IfComp>
                </TileContent>
            </Stack>
        </AppPageStyle>
    );
}

export default AppsPage;
